module.exports = __webpack_public_path__ + "static/img/dd-target-icon-01.c7f5b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-target-icon-01.png
// module id = 5ReH
// module chunks = 1